export const bcAddressRegex = /^0x[a-fA-F0-9]{40}$/g
export const secretIdRegex = /^[a-fA-F0-9]{24}$/g
